import { API_URL } from '../../helpers/constants';
export async function newHireRequest(path,body,method) {
 const response=await fetch(String(API_URL || '').replace(/\/$/,'')+'/onboarding/'+path,{method:method||(body?'POST':'GET'),credentials:'include',headers:{'Content-Type':'application/json','X-MHC-Onboarding':'1'},body:body?JSON.stringify(body):undefined,cache:'no-store'});
 const result=await response.json();
 if(!response.ok)throw new Error(response.status===401?'Your session expired. Sign in again to continue.':result.message||'Paperwork could not be processed.');
 return result;
}
export function downloadNewHire(file){
 const raw=atob(file.data),bytes=Uint8Array.from(raw,c=>c.charCodeAt(0)),url=URL.createObjectURL(new Blob([bytes],{type:'application/pdf'}));
 const link=document.createElement('a');link.href=url;link.download=file.fileName;document.body.appendChild(link);link.click();link.remove();setTimeout(()=>URL.revokeObjectURL(url),30000);
}
export function authDestination(user,returnTo){return user?.onboardingRequired?'/onboarding':returnTo||'/';}
